import { useSearchParams } from 'react-router-dom'

import { MediumIcon, Variants } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { useExpensesNavigation } from 'modules/expenses/hooks/useExpensesNavigation'

interface usePageActionsProps {
  isInMyExpensesSection: boolean
  canUsePerDiems: boolean
  canCreateExpenses: boolean
  expensableGroupsEnabled: boolean
}

interface PrimaryAction {
  label: string
  icon?: MediumIcon | false
  variant?: Variants
  key?: string
  to: {
    pathname: string
    search: string
  }
}

interface SecondaryAction {
  to: string
  title: string
  key?: string
}

interface PageActionsActions {
  primary?: PrimaryAction[]
  secondary?: SecondaryAction[]
}

interface UsePageActionsReturn {
  actions: PageActionsActions
}

export const usePageActions = ({
  isInMyExpensesSection,
  canUsePerDiems,
  canCreateExpenses,
  expensableGroupsEnabled,
}: usePageActionsProps): UsePageActionsReturn => {
  const [searchParams] = useSearchParams()
  const { navigation } = useExpensesNavigation()

  const primaryActions: PrimaryAction[] = []
  const secondaryActions: SecondaryAction[] = []

  if (canCreateExpenses && isInMyExpensesSection) {
    primaryActions.push({
      label: i18n.t('command_bar.plugins.actions.my_expenses.add_new_expense'),
      key: 'new_expense',
      to: {
        pathname: navigation.helpers.newExpenseOcr(),
        search: searchParams.toString(),
      },
    })
    primaryActions.push({
      label: i18n.t('command_bar.plugins.actions.my_expenses.add_new_mileage'),
      key: 'new_mileage',
      to: {
        pathname: navigation.helpers.newMileage(),
        search: searchParams.toString(),
      },
    })
  }

  if (canCreateExpenses && canUsePerDiems && isInMyExpensesSection) {
    primaryActions.push({
      label: i18n.t('command_bar.plugins.actions.my_expenses.add_new_per_diem'),
      key: 'new_per_diem',
      to: {
        pathname: navigation.helpers.newPerDiem(),
        search: searchParams.toString(),
      },
    })
  }
  if (canCreateExpenses && expensableGroupsEnabled && isInMyExpensesSection) {
    primaryActions.push({
      label: i18n.t('command_bar.plugins.actions.my_expenses.add_new_group'),
      key: 'new_group',
      to: {
        pathname: navigation.helpers.newGroup(),
        search: searchParams.toString(),
      },
    })
  }

  secondaryActions.push({
    to: navigation.exporter.fullPath(),
    key: 'exporter',
    title: i18n.t('expenses_v2.modals.export.my_expenses.title'),
  })

  return { actions: { primary: primaryActions, secondary: secondaryActions } }
}
